import { FormArray, FormControl, FormGroup } from '@angular/forms';

import { LicenseForm } from './license-form';
import { PrimaryTradeForm } from './primary-trade-form';
import { PrimaryTradeLicenseRequirementForm } from './primary-trade-license-requirement-form';
import { TradeLicenseForm } from './trade-license-form';

export class VendorTradeForm extends FormGroup<{
  id: FormControl<number | undefined>;
  isPrimary: FormControl<boolean>;
  VendorId: FormControl<number | undefined>;
  ExemptVendorId: FormControl<number | undefined>;
  PrimaryTradeId: FormControl<number | undefined>;

  PrimaryTrade?: PrimaryTradeForm;
  Licenses?: FormArray<LicenseForm>;
  PrimaryTradeLicenseRequirements?: FormArray<PrimaryTradeLicenseRequirementForm>;
  TradeLicenses?: FormArray<TradeLicenseForm>;
}> {
  constructor() {
    super({
      id: new FormControl<number | undefined>(undefined, { nonNullable: true }),
      isPrimary: new FormControl<boolean>(false, { nonNullable: true }),
      VendorId: new FormControl<number | undefined>(undefined, {
        nonNullable: true
      }),
      ExemptVendorId: new FormControl<number | undefined>(undefined, {
        nonNullable: true
      }),
      PrimaryTradeId: new FormControl<number | undefined>(undefined, {
        nonNullable: true
      })
    });
  }
}
